module.exports = __webpack_public_path__ + "img/artFuture.6cf1788c.gif";